import styled, { css } from 'styled-components/macro';
import { ButtonRectangleRadioStyled } from '@yme/atoms/button-select/styled';
import { RadioButtonContainerStyled } from '@yme/atoms/radio-button/styled';
import { Link } from '@yme/components/Link';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { BREAKPOINT } from '@yme/tokens/screen';
export const FlexWrapperStyled = styled(FlexWrapper) `
  @media only screen and (max-width: 520px) {
    flex-direction: ${({ isSquareButton }) => (isSquareButton ? 'row' : 'column')};
  }

  @media (min-width: 521px) and (max-width: ${BREAKPOINT.lg}px) {
    flex-direction: row;
  }

  @media (min-width: ${BREAKPOINT.lg}px) and (max-width: ${BREAKPOINT.xlg}px) {
    flex-direction: ${({ isSquareButton }) => (isSquareButton ? 'row' : 'column')};
  }

  @media (min-width: ${BREAKPOINT.xlg}px) {
    flex-direction: row;
  }

  ${({ isSquareButton }) => isSquareButton &&
    css `
      ${ButtonRectangleRadioStyled} {
        justify-content: center;
        width: auto;
        height: 44px;
        min-width: 44px;
        padding: 10px;

        ${RadioButtonContainerStyled} {
          display: none;
        }
      }
    `}
`;
export const AlertLinkStyled = styled(Link) `
  color: ${colorCoreBlack900Base};
`;
